import { GAEventName } from '../ga-event-name.enum';

export const statsigFilters = {
  [GAEventName.PURCHASE]: (event: Record<string, any>) => ({
    ecommerce: event.ecommerce,
    tracking: event.checkoutData?.tracking || {},
    store: event.store,
    customer_data: event.checkoutData?.customer_data || {}
  })
} as Record<string, (event: Record<string, any>) => Record<string, any>>;
